const SldsRadioButtonGroup = () => {
    return (
        <fieldset class="slds-form-element" role="radiogroup">
            <div class="slds-form-element__control">
                <div class="slds-radio_button-group">
                    <span class="slds-button slds-radio_button">
                        <input type="radio" name="example-unique-name-197" id="example-unique-id-199" value="monday" />
                        <label class="slds-radio_button__label" for="example-unique-id-199">
                            <span class="slds-radio_faux">Mon</span>
                        </label>
                    </span>
                    <span class="slds-button slds-radio_button">
                        <input type="radio" name="example-unique-name-197" id="example-unique-id-200" value="tuesday" />
                        <label class="slds-radio_button__label" for="example-unique-id-200">
                            <span class="slds-radio_faux">Tue</span>
                        </label>
                    </span>
                    <span class="slds-button slds-radio_button">
                        <input type="radio" name="example-unique-name-197" id="example-unique-id-201" value="wednesday" />
                        <label class="slds-radio_button__label" for="example-unique-id-201">
                            <span class="slds-radio_faux">Wed</span>
                        </label>
                    </span>
                    <span class="slds-button slds-radio_button">
                        <input type="radio" name="example-unique-name-197" id="example-unique-id-202" value="thursday" />
                        <label class="slds-radio_button__label" for="example-unique-id-202">
                            <span class="slds-radio_faux">Thu</span>
                        </label>
                    </span>
                    <span class="slds-button slds-radio_button">
                        <input type="radio" name="example-unique-name-197" id="example-unique-id-203" value="friday" />
                        <label class="slds-radio_button__label" for="example-unique-id-203">
                            <span class="slds-radio_faux">Fri</span>
                        </label>
                    </span>
                </div>
            </div>
        </fieldset>
    )
}

export default SldsRadioButtonGroup;